export const lineColors = [
    "#AFAFAF","#404E5C","#7C91B0",
    "#006687","#0093AF","#5AD8DC",
    
    "#8DB580","#B0D391","#8D74A3",
    "#DD9AC2","#CC4814","#F8782E",

    "#D08E30","#F3B803","#AE1833",
    "#F34258","#6E262A",
];